import {
  BffChargeTimeConfigurationResponse,
  BffCostConfigurationResponse,
  BffRangeConfigurationResponse,
  SimulatorFeatureAppName,
  NonSimulatorFeatureAppName,
} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import {ServiceConfigEndpointProvider} from '@volkswagen-onehub/service-config-endpoint-provider';

export const getFeatureAppConfigurationEndpoint = (
  custom?: string,
  featureApp?: NonSimulatorFeatureAppName
) => {
  const prefix = '/ms/';
  if (featureApp) {
    return `${prefix}${featureApp}-${custom ? 'custom-' : ''}configuration`;
  }
  return `${prefix}${custom ? 'custom-' : ''}configuration`;
};

export interface EncodedBffConfigurationParameters {
  language: string;
  countryCode: string;
  featureAppName: string;
  serviceConfigsServiceConfig: string;
  mockIds?: string;
  cacheBuster?: string;
}

export interface BffOptionsParameters {
  frontSideImage?: boolean;
}

export interface DecodedBffConfigurationParameters {
  language: string;
  countryCode: string;
  featureAppName?: SimulatorFeatureAppName;
  serviceConfigEndpointProvider: ServiceConfigEndpointProvider;
  mockIds: Set<string>;
  cacheBuster: string | undefined;
  debug: string | undefined;
  options?: BffOptionsParameters;
}

export type BffConfigurationResponseMap = {
  [SimulatorFeatureAppName.Range]: BffRangeConfigurationResponse;
  [SimulatorFeatureAppName.Chargetime]: BffChargeTimeConfigurationResponse;
  [SimulatorFeatureAppName.Cost]: BffCostConfigurationResponse;
};
